import {isTestEnv} from 'common/report/util/env';

/**
 * Safari has a bug where not enough error information is passed from scripts in an iframe causing benign
 * errors from ResizeObserver ("ResizeObserver loop completed with undelivered notifications.") from being caught and
 * filtered, we force the use of the polyfill to bypass that bug
 *
 * More info: https://bugs.webkit.org/show_bug.cgi?id=132945
 */
if (isTestEnv() && [`firefox`, `safari`].some((browser) => navigator.userAgent.toLowerCase().includes(browser))) {
  delete window.ResizeObserver;
}
